import { render } from "./ListaBudget.vue?vue&type=template&id=88a6b838&ts=true"
import script from "./ListaBudget.vue?vue&type=script&lang=ts"
export * from "./ListaBudget.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__